<div class="lib-widget-view-wrapper">
    <div #obcNavigationInstrumentContainer class="navigations-instrument-wrapper">
        <div class="obc-instrument-field-wrapper">
            <obc-instrument-field
                    [setpoint]="obcInstrumentFieldInstance.instrumentField.setpoint"
                    [hasSetpoint]="obcInstrumentFieldInstance.instrumentField.hasSetpoint"
                    [value]="obcInstrumentFieldInstance.instrumentField.value"
                    [degree]="obcInstrumentFieldInstance.instrumentField.degree"
                    [tag]="obcInstrumentFieldInstance.instrumentField.tag"
                    [unit]="obcInstrumentFieldInstance.instrumentField.unit"
                    [source]="obcInstrumentFieldInstance.instrumentField.source"
                    [hasSource]="obcInstrumentFieldInstance.instrumentField.hasSource"
                    [fractionDigits]="obcInstrumentFieldInstance.instrumentField.fractionDigits"
            ></obc-instrument-field>
        </div>
    </div>
</div>
